import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from "react-i18next";
import Modal from './shared/modal'
import AgeSlider from './AgeSlider'

const initialState = { category_ids: [], from_age: 5, to_age: 15 }

const FiltersModalButton = ({ filters, onChange, categories }) => {
  const [show, setShow] = useState(false);
  const [params, setParams] = useState(initialState)

  const { t } = useTranslation();

  useEffect(() => {
    resetFilterParams();
  }, [filters])

  const resetFilterParams = () => {
    const { category_ids, from_age, to_age } = filters;

    setParams({ ...params, category_ids: split(category_ids), from_age: from_age || 5, to_age: to_age || 15 })
  }

  const join = (categories) => {
    return (categories || []).join(',')
  }

  const split = (categories) => {
    if (!categories || categories?.length === 0) return [];
    return categories.split(',').filter(i => !!i)
  }

  const save = (update) => {
    if (update) {
      onChange && onChange(prepapreParams(params))
    } else {
      resetFilterParams()
    }
    setShow(false);
  }

  const clear = () => {
    if (onChange) {
      onChange && onChange(prepapreParams(initialState))
    } else {
      setParams(initialState)
    }

    setShow(false);
  }

  const prepapreParams = (parameters) => {
    return { ...parameters, category_ids: join(parameters?.category_ids) }
  }

  const selectCategory = (category_id) => {
    let selectedCategories = [...params.category_ids]
    category_id = `${category_id}`;
    if (selectedCategories.includes(category_id)) {
      selectedCategories = selectedCategories.filter(id => id != category_id)
    } else {
      selectedCategories.push(category_id)
    }

    setParams({...params, category_ids: selectedCategories})
  }

  const filtersApplied = useMemo(
    () => {
      const { category_ids, from_age, to_age } = filters;
      const filtersApplied = !!category_ids?.length || from_age && from_age > 5 || to_age && to_age < 15;

      return filtersApplied;
    },
    [filters]
  );


  return (
    <div className="filters-modal-button">
      <div className='pointer relative' onClick={() => setShow(true)}>
        { filtersApplied && <i className='icon-info-absolute icon icon-info' /> }
        <img src='/images/icons/show-filters.svg' alt='Filter' className='mr10' />
        {t('filtersModalButton.show_filters')}
      </div>
      <Modal openModal={show} closeModal={() => setShow(false)}>
        <div className="flex1 flex-column filters-modal">
          <div>{t('filtersModalButton.available_filters')}</div>
          <div className='heading'>{t('common.year_span')}</div>
          <AgeSlider
            minimum_age={params.from_age}
            maximum_age={params.to_age}
            onChange={({ minimum_age: from_age, maximum_age: to_age }) => setParams({ ...params, from_age, to_age })} />


          {categories && categories?.length > 0 &&
            <div>
              <div className='heading'>{t('filtersModalButton.label')}</div>
              <div className='tags-container'>
                <div className='tags'>
                  {categories.map(category =>
                     <button key={category.id} onClick={() => selectCategory(category.id)} className={`button button-category mr10 ${params.category_ids?.includes(`${category.id}`) ? 'active' : ''}`}>
                      {category.title}
                    </button>)}
                </div>

              </div>
            </div>
          }
        </div>


        <hr />
        <div className='form-container-actions'>
          <button className="button" onClick={clear}>{t('filtersModalButton.clear_filters')}</button>
          <div className='flex-end'>
            <button className="button" onClick={() => save(false)}>{t('buttons.common.cancel')}</button>
            <button className="button button-primary" onClick={() => save(true)}>{t('buttons.common.update')}</button>
          </div>
        </div>

      </Modal>
    </div>
  )
}

export default FiltersModalButton;